// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as LinkExternalADefault } from '../../../../../ui-v3/src/assets/icons/default/general/link-external-a.svg?react';
import { ReactComponent as LinkExternalASolid } from '../../../../../ui-v3/src/assets/icons/solid/general/LINK-EXTERNAL-A.svg?react';
import { createIcons } from '../../Icon';
const LinkExternalAIcon = /* @__PURE__ */ createIcons('LinkExternalA', {
    default: LinkExternalADefault,
    solid: LinkExternalASolid
});
LinkExternalAIcon.supportedTypes = [
    'default',
    'solid'
];
LinkExternalAIcon.category = 'general';
export default LinkExternalAIcon;
